import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import { BreadcrumbCompactsContext } from './BreadcrumbCompacts';
import styled from './styles';

export interface BreadcrumbTextProps extends React.ComponentPropsWithRef<'div'> {
  /** Displayed text for this breadcrumb */
  text?: string;
  /** secondaryText of a breadcrumb */
  secondaryText?: string;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/**
 * Single breadcrumbText component.
 * Any other props than `text` and `secondaryText` will be provided to the root element. */
const BreadcrumbText = React.forwardRef<HTMLElement, BreadcrumbTextProps>((props: BreadcrumbTextProps, ref) =>
  getContext(({ RTL, theme }) => {
    const {
      text,
      secondaryText,
      theme: themeProp,
      ...otherProps
    } = props;
    const { isCompact } = React.useContext(BreadcrumbCompactsContext);
    const resolvedTheme = _merge({}, theme ? theme.BREADCRUMBS : {}, themeProp);

    return (
      <styled.BreadcrumbTextContainer ref={ref} $rtl={RTL} $isCompact={isCompact} {...otherProps}>
        <styled.BreadcrumbMainText RTL={RTL} $theme={resolvedTheme}>{text}</styled.BreadcrumbMainText>
        {secondaryText && <styled.BreadcrumbSecondText RTL={RTL} $theme={resolvedTheme}>{secondaryText}</styled.BreadcrumbSecondText>}
      </styled.BreadcrumbTextContainer>
    );
  }));

BreadcrumbText.displayName = 'BreadcrumbText';

BreadcrumbText.defaultProps = {
  text: '',
  secondaryText: undefined,
  theme: {},
};

export default BreadcrumbText;
